export default {
  Market: "Рыночные",
  Rates: "ставки",
  AddNew: "+ Добавить",
  ThisWeek: "за текущую неделю",
  PlusAddNew: "Добавить",
};
